define('apps/course-intro/views/regions/badges/badge-grid',[
    'apps/course-intro/views/items/badge'
], function (BadgeView) {
    "use strict";

    return Mn.CollectionView.extend({

        "tagName": "ul",

        "className": "badge-grid",

        "childView": BadgeView,

        "childViewOptions": function (model) {
            return {
                "itemIndex": this.collection.indexOf(model),
                "levelGuid": this.collection.levelGuid,
                "levelNum": this.collection.levelNum
            };
        }
    });
});


